import React from 'react';
import { useTranslation } from 'react-i18next';
import { getFormattedExpirationTime } from '@/utils/TasId';

const CombtasBar = (props) => {
	const { tasId, endCombtasSession } = props;
	const { t } = useTranslation();
	const expirationTime = getFormattedExpirationTime();

	return (
		<div className="combtas-bar">
			<div className="combtas-session">
				{t('Combtas.BookingSession')} <span className="tas-id">{tasId}</span>
				{expirationTime && (
					<span className="end-time">
						{t('Combtas.EndsAt')} {expirationTime}
					</span>
				)}
			</div>
			<button className="end-session-button" onClick={() => endCombtasSession()}>
				{t('Combtas.EndNow')}
			</button>
		</div>
	);
};

export default CombtasBar;
